export default __webpack_public_path__ + "static/engageBayImage-1a402e79f01aacd2f0f6e4aa727f6de0.webp";